module.exports = __webpack_public_path__ + "static/media/location.b9d30eec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = 110
// module chunks = 0